<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
	<div class="cards-holder devices-tab">
		<div class="card card2 mRight" id="display-creative-v3-chart-container">
			<div class="no-data-container" *ngIf="!hasData && !showLoad">
				<div class="map-no-data">No Data to Display</div>
			</div>

			<div [hidden]="!hasData && !showLoad">
				<app-datatable-v4
					[sectiontitle]="sectiontitle"
					[datatableconfig]="datatableconfig"
					[key]="key"
					[isVerticalScrollable]="true"
					[rowHeight]="50"
					[is_card_mleft_not_required]="true"
					[defaultsort]="defaultsort"
					[iscustomendpoint]="iscustomendpoint"
				></app-datatable-v4>

				<div class="o-stack__cell">
					<h5 class="creative-charts-header creative-charts-header-with-download">{{ sectiontitle }} {{ timezone }}</h5>
					<span class="datatable-icon">
						<a
							href="javascript:void(0)"
							class="datatable_download_icon"
							(click)="downloadCSV()"
							target="_blank"
							*ngIf="datatableconfig.enableDownload"
						>
							<i class="fa fa-download" aria-hidden="true"></i>
						</a>
					</span>
				</div>
			</div>
		</div>
		<div
			class="card card1 mLeft devices-carousel creative-performance-stats cardcardcardcardcardcarddisplay-creative-container"
		>
			<app-loader [showLoader]="showLoadForDayPart"></app-loader>
			<div class="preRoll-creative-completion-stats-container">
				<div class="c-portlet__header o-stack__cell day_part">
					<h5>Time of Day {{ timezone }}</h5>
				</div>
				<div
					class="analytics-portlet-content"
					[hidden]="!hasDaypartData && !showLoadForDayPart"
					style="position: relative; height: 95%; z-index: 0"
				>
					<div class="o-stack o-stack--nowrap o-stack--center ht-100">
						<div class="donut-chart-container">
							<div class="chart-wrapper">
								<div class="chart-inner">
									<div #chartElementId id="donut-chart" style="width: 100%; height: 100%"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div *ngIf="!hasDaypartData && !showLoadForDayPart">
					<div class="map-no-data">No Data to Display</div>
				</div>
			</div>
		</div>
	</div>
</div>
